import { ROUTE_ITINERARY_COMPUTING_BY_MODE } from '..'
import { renderPage } from '../../domain/itinerary/itinerary-expense-report.page'
import { navigateTo } from '../../store/history/history.actions'
import { selectCurrentRoute } from '../../store/itinerary/routes.selectors'
import { fetchItineraryOptionsConfig } from '../../store/itineraryOptions/itineraryOptions.actions'
import { wait } from '../../utils/function'
import { handleRouteLoading } from '../routeService'

const onRouteEnter = ({ params = {}, store: { dispatch, getState } }) => {
  const { mode, from, to } = params
  const currentRoute = selectCurrentRoute(getState())

  if (!currentRoute) {
    return wait(100).then(() =>
      navigateTo({
        route: ROUTE_ITINERARY_COMPUTING_BY_MODE,
        routeOptions: {
          from,
          to,
          mode,
        },
      })(dispatch, getState)
    )
  }

  return fetchItineraryOptionsConfig()(dispatch, getState)
}

export default handleRouteLoading({ onRouteEnter, renderPage })
